import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-pending-conditionals',
  templateUrl: './pending-conditionals.component.html',
  styleUrls: ['./pending-conditionals.component.css']
})
export class PendingConditionalsComponent implements OnInit {
  paramRouter: any;
  tableItens: any[] = [];
  tableItensGeral: any[] = [];
  productList: any[] = [];

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private poNotification: PoNotificationService) {}

  ngOnInit(): void {
    this.api.setHeader();
    this.route.queryParams.subscribe((item: any) => {
      this.paramRouter = item;
    })
    this.filterItem();
  }

  filterItem() {
    if (this.paramRouter.branch != undefined) {
      this.pendingConditionalsReturn().subscribe((data: any) => {
        this.tableItens = data.dataRow;
        data.dataRow.map((el: any) => {
          this.tableItensGeral.push({
            personName: el.personName,
            personCode: el.personCode,
            phoneNumber: el.phoneNumber,
            adress: el.adress,
            adressName: el.adressName,
            quantityDays: el.quantityDays,
            productQuantity: el.productQuantity,
            productValue: parseFloat(el.productValue).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'}),
          })
        });
      });
    }
  }

  pendingConditionalsReturn() {
    return this.api.postPendingConditionalsSellerPanel(this.paramRouter.branch);
  }

  clickView(cod: string) {
    this.tableItens.map((el: any, index: any) => {
      if (el.personCode === Number(cod)) {
        this.productList[index] = [];
        el.productList.map((elPerson: any) => {
          this.productList[index].push({
            'Código': elPerson.productCode,
            'Descrição': elPerson.productDescription,
            'Preço': parseFloat(elPerson.balanceValue).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'}),
            'Qtd': elPerson.balanceQuantity 
          })
        })
      }
    })
    let testeViw = document.getElementById(cod);
    if (testeViw!.classList.contains('invisivel')) {
        testeViw!.classList.remove('invisivel');
        testeViw!.classList.add('visivel po-row po-p-1');
    } else {
        testeViw!.classList.remove('visivel');
        testeViw!.classList.add('invisivel');
    }
  }

  backHome() {
    this.router.navigate(['/home/salers']);
  }

  copyContact(item: any) {
    navigator.clipboard.writeText(item).then(() => {
      this.poNotification.success('contato copiado com sucesso!');
    }).catch((err: any) => {
      this.poNotification.error('Erro ao copiar o contato!');
    });
  }

  sendWa(item: any) {
    const encodedMessage = encodeURIComponent(CONSTANTS.MESSAGES.DATA_MESSAGE_WHATSAPP);
    const plusCountry = '55' + item.replace(/\D/g, '');
    const url = `https://wa.me/${plusCountry}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }

}
